import { useState } from "react";
import { useCurrentStateAndParams } from "@uirouter/react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Autocomplete } from "@similarweb/ui-components";

import AutocompleteTopics, {
    AutocompleteTopicsWrapper,
} from "pro-features/components/AutocompleteTopics/AutocompleteTopics";

import type { IDemandAnalysisHomePageParams } from "../../../types";
import type { Topic } from "../../../api-client/demandSearchTrendsTopicsAPI";

const StyledAutocomplete = styled(Autocomplete)<{ isOpened: boolean }>`
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    height: 56px;

    .AutoCompleteContainer {
        padding: 0;
        border: none;
        transform: none;
        border-radius: none;
    }

    ${AutocompleteTopicsWrapper} {
        padding-top: 0;
    }

    .input-container {
        border-radius: 0;
        height: 56px;
        padding-top: 7px;
        padding-bottom: 9px;
        border-bottom: ${({ isOpened }) =>
            isOpened ? `1px solid ${colorsPalettes.blue[400]}` : `1px solid ${colorsPalettes.carbon[100]}`};
    }

    svg {
        width: 24px;
        height: 24px;
    }
`;

type TopicsDiscoverAllTopicsModalSearchProps = {
    flattenedData: Topic[];
};

export const TopicsDiscoverAllTopicsModalSearch = ({ flattenedData }: TopicsDiscoverAllTopicsModalSearchProps) => {
    const { params } = useCurrentStateAndParams<IDemandAnalysisHomePageParams>();
    const [query, setQuery] = useState("");
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);

    const onAutocompleteFocus = () => {
        setIsAutocompleteOpen(true);
    };
    const onAutocompleteBlur = () => {
        setIsAutocompleteOpen(false);
    };

    const getAutocompleteItems = (query: string) => {
        setQuery(query);
        const queryRegexp = new RegExp(query, "i");
        return flattenedData.filter((item: Topic) => item.Level !== 1 && queryRegexp.test(item.Name));
    };

    const renderAutocompleteItems = (data: { listItems: Topic[]; selectedItemId: number }) => {
        if (!data.listItems.length) {
            return null;
        }

        return (
            <AutocompleteTopics
                topics={data.listItems}
                selectedItemId={data.selectedItemId}
                query={query}
                hasQuery={Boolean(query)}
                countryId={params.country}
            />
        );
    };

    return (
        <StyledAutocomplete
            isOpened={isAutocompleteOpen}
            onFocus={onAutocompleteFocus}
            onBlur={onAutocompleteBlur}
            getListItems={getAutocompleteItems}
            renderItems={renderAutocompleteItems}
        />
    );
};
